import React from 'react'
import ButtonWithIcon from 'ui/buttons/ButtonWithIcon'
import SVGIcon from 'ui/helpers/SVGIcon'
import CartBanner from 'services/cart/CartBanner'
import { Link } from '@morningtrain/react-navigation'
import CheckoutEventOnPipe from 'services/googleAnalytics/CheckoutEventOnPipe'

export default function DefaultCartBanner () {
  return (
    <CartBanner>
      <Link route='app.shop.cart.index' pipeline={<CheckoutEventOnPipe />}>
        <ButtonWithIcon text='Gå til kurv' iconPath={<SVGIcon type='cart' className='-ml-1 mr-2 h-5 w-5' />} color='white' />
      </Link>
    </CartBanner>
  )
}
